const isMTI =
  process.env.REACT_APP_CLIENT_TOKEN === '1b882a3e-747b-4f00-87f9-2b455735203e'
    ? true
    : false;

export { isMTI };
